module.exports = __webpack_public_path__ + "img/img2.8be34a2d.png";